export default "/institutions/pan.svg";